<template>
    <div>
        <!-- Formulaire -->
        <form :action="formUrl(type)" class="space-y-1" method="post">
            <input type="hidden" name="_token" :value="props.csrfToken">
            <div class="px-4 py-1 " v-show="stat===1">
                <div class="mb-6 text-center">
                    <h4 style="font-weight: bold; font-size: 35px;">
                        Inscrivez-vous et <br>
                        profitez des meilleurs contenus
                    </h4>
                </div>
                <div class="grid grid-cols-2 gap-4 space-y-2">
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700 block">Nom d'utilisateur</label>
                        <input
                            required
                            type="text"
                            name="name"
                            placeholder="Nom d'utilisateur"
                            class="w-full px-4 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993] focus:outline-none input-focus transition-all duration-200 text-gray-700"
                        >
                    </div>
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700 block">Email</label>
                        <div class="relative">
                            <input
                                required
                                type="email"
                                name="email"
                                placeholder="nom@email.com"
                                class="w-full pl-4 pr-10 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993]
                                       focus:outline-none transition-all duration-200 text-gray-700"
                            >
                            <!-- Icône email SVG -->
                            <svg class="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400"
                                 fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                            </svg>
                        </div>
                    </div>
                </div>

                <div class="space-y-2">
                    <label class="text-sm font-medium text-gray-700 block">Nom</label>
                    <input
                        required
                        type="text"
                        name="first_name"
                        placeholder="nom"
                        class="w-full px-4 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993] focus:outline-none input-focus transition-all duration-200 text-gray-700"
                    >
                </div>
                <div class="space-y-2">
                    <label class="text-sm font-medium text-gray-700 block">Prenom</label>
                    <input
                        required
                        type="text"
                        name="last_name"
                        placeholder="Prenom"
                        class="w-full px-4 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993] focus:outline-none input-focus transition-all duration-200 text-gray-700"
                    >
                </div>

                <!-- Champs conditionnels pour Invité -->
                <transition name="fade">
                    <div v-if="type==='Guest'" class="space-y-2">
                        <label class="text-sm font-medium text-gray-700 block">Téléphone</label>
                        <input
                            required
                            type="tel"
                            name="phone"
                            placeholder="+227 xx xx xx xx"
                            class="w-full px-4 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993] focus:outline-none input-focus transition-all duration-200 text-gray-700"
                        >
                    </div>
                </transition>

                <!-- Mots de passe -->
                <div class="grid grid-cols-2 gap-4">
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700 block">Mot de passe</label>
                        <div class="relative">
                            <input
                                required
                                :type="showPassword ? 'text' : 'password'"
                                name="password"
                                id="passwordInput"
                                placeholder="••••••••••••"
                                class="w-full pl-4 pr-10 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993]
                                       focus:outline-none transition-all duration-200 text-gray-700"
                            >
                            <button type="button" @click="togglePasswordVisibility('password')"
                                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
                                <!-- Icône œil ouvert -->
                                <svg v-if="showPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                </svg>
                                <!-- Icône œil fermé -->
                                <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="space-y-2">
                        <label class="text-sm font-medium text-gray-700 block">Confirmer</label>
                        <div class="relative">
                            <input
                                required
                                :type="showConfirmPassword ? 'text' : 'password'"
                                name="password_confirmation"
                                id="confirmPasswordInput"
                                placeholder="••••••••••••"
                                class="w-full pl-4 pr-10 py-3 rounded-sm border border-gray-200 focus:border-[#2A3993]
                                       focus:outline-none transition-all duration-200 text-gray-700"
                            >
                            <button type="button" @click="togglePasswordVisibility('confirm')"
                                    class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors">
                                <!-- Icône œil ouvert -->
                                <svg v-if="showConfirmPassword" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                                </svg>
                                <!-- Icône œil fermé -->
                                <svg v-else class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Boutons -->
                <div class="flex space-x-3 pt-4">
                    <a
                        :href="route('login')"
                        class="flex-1 text-center text-gray border border-gray-200 py-3 px-6 rounded-md font-semibold hover:bg-[#2A3993] hover:text-white hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
                    >
                        Connexion
                    </a>
                    <button
                        @click.prevent="changeStat"
                        type="button"
                        class="flex-1 bg-[#2A3993] text-white py-3 px-6 text-center rounded-md font-semibold hover:bg-[#2A3993] hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
                    >
                        Suivant
                    </button>
                </div>
            </div>

            <!-- Étape 2: Sélection des catégories -->
            <div v-show="stat===2">
                <div class="flex items-center justify-between p-6 border-b border-gray-100">
                    <div>
                        <h2 class="text-2xl font-bold text-gray-800 text-center">Sélection des catégories</h2>
                        <p class="text-gray-600 mt-1 text-center">Choisissez les catégories de livres qui vous
                            intéressent</p>
                    </div>
                </div>

                <div class="p-6 overflow-y-auto max-h-96">
                    <div class="mb-6">
                        <div class="flex flex-wrap gap-2">
                            <button
                                @click="selectAll"
                                type="button"
                                class="px-4 py-2 bg-indigo-100 text-[#2A3993] rounded-sm hover:bg-[#2A3993]/25 transition-colors duration-200 text-sm font-medium"
                            >
                                Tout sélectionner
                            </button>
                            <button
                                @click="deselectAll"
                                type="button"
                                class="px-4 py-2 bg-gray-100 text-gray-700 rounded-sm hover:bg-gray-200 transition-colors duration-200 text-sm font-medium"
                            >
                                Tout désélectionner
                            </button>
                        </div>
                    </div>

                    <!-- Liste des catégories -->
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        <div
                            v-for="category in filteredCategories"
                            :key="category.id"
                            class="group"
                        >
                            <label
                                class="flex items-center p-4 border border-gray-200 rounded-sm hover:border-[#2A3993]/25 hover:bg-indigo-50 transition-all duration-200 cursor-pointer group-hover:shadow-md"
                            >
                                <input
                                    v-model="selectedCategories"
                                    :value="category.id"
                                    type="checkbox"
                                    name="categorieIds[]"
                                    class="w-5 h-5 text-[#2A3993] rounded border-gray-300 focus:ring-[#2A3993] focus:ring-2"
                                >
                                <div class="ml-3 flex-1">
                                    <div class="flex items-center">
                                        <span class="text-2xl mr-3">{{ category.icon }}</span>
                                        <div>
                                            <span
                                                class="block text-sm font-semibold text-gray-800 group-hover:text-[#2A3993]">
                                                {{ category.wording }}
                                            </span>

                                        </div>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="px-6 py-4 border-t border-gray-100 bg-gray-50 flex items-center justify-between">
                    <div class="text-sm text-gray-600">
                        {{ selectedCategories.length }} catégorie(s) sélectionnée(s)
                    </div>
                    <div class="flex space-x-3">
                        <button
                            @click="stat = 1"
                            type="button"
                            class="px-6 py-2 text-gray rounded-sm font-semibold hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
                        >
                            Retour
                        </button>
                        <button
                            type="submit"
                            :disabled="selectedCategories.length === 0"
                            class="px-6 py-2 bg-[#2A3993] text-white rounded-sm font-semibold hover:bg-[#2A3993] disabled:bg-gray-300 disabled:cursor-not-allowed hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl"
                        >
                            Valider
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script setup>
import {ref, computed, watch} from 'vue'
import XSelect from "@/vue/Form/XSelect.vue";
import {route} from "@/helper.js";

// Props
const props = defineProps({
    categories: {
        type: Array,
        default: () => []
    },
    modelValue: {
        type: Array,
        default: () => []
    },
    logo: String,
    csrfToken: String,
})

function ucfirst(str) {
    if (!str) return str
    return str.charAt(0).toUpperCase() + str.slice(1)
}

const formUrl=(type)=>{
    return route('register',{type:ucfirst(type)})
}

// Emits
const emit = defineEmits(['update:modelValue', 'submit'])

// État réactif
const type = ref('Guest')
const stat = ref(1)
const selectedCategories = ref([...props.modelValue])
const searchTerm = ref('')
const showPassword = ref(false)
const showConfirmPassword = ref(false)

// Computed
const filteredCategories = computed(() => {
    if (!searchTerm.value) {
        return props.categories
    }

    const term = searchTerm.value.toLowerCase()
    return props.categories.filter(category =>
        category.wording.toLowerCase().includes(term)

    )
})

// Méthodes
const changeStat = () => {
    stat.value = 2
    selectedCategories.value = [...props.modelValue]
}

const togglePasswordVisibility = (field) => {
    if (field === 'password') {
        showPassword.value = !showPassword.value
    } else if (field === 'confirm') {
        showConfirmPassword.value = !showConfirmPassword.value
    }
}

const selectAll = () => {
    selectedCategories.value = filteredCategories.value.map(cat => cat.id)
}

const deselectAll = () => {
    selectedCategories.value = []
}

// Watchers
watch(() => props.modelValue, (newVal) => {
    if (newVal && Array.isArray(newVal)) {
        selectedCategories.value = [...newVal]
    }
}, {immediate: true})

</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

/* Cacher les radio buttons visuellement mais les garder accessibles */
.sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
}

/* Animation pour les checkboxes */
input[type="checkbox"]:checked {
    animation: checkbox-bounce 0.2s ease-in-out;
}

@keyframes checkbox-bounce {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.1);
    }
    100% {
        transform: scale(1);
    }
}

/* Styles pour le scroll personnalisé */
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}
</style>
